import{e as n,m as t}from"./chunk-HBP5N4FR.js";var g,r=n(()=>{t();g=s=>/\d/.test(s)});export{g as a,r as b};
//# sourceMappingURL=chunk-CCJG3WLD.js.map
